<template>
  <tk-container :status="status" @refresh="getInit">
    <tkui-header
      slot="header"
      center
      class="primary-header"
    >隐私协议</tkui-header>
    <div class="agreement-box" v-if="agreementData" v-html="agreementData"></div>
  </tk-container>
</template>

<script>
export default {
  data () {
    return {
      status: 'loading',
      privacyNotice: null
    }
  },
  mounted () {
    this.getInit()
  },
  computed: {
    agreementData () {
      return this.privacyNotice
    }
  },
  methods: {
    async getInit () {
      try {
        const privacyPolicy = await this.$tkParse.get('https://cloud.dianpei.mokekeji.com/settings/privacyPolicy').catch(e => {
          return { data: null }
        })
        if (privacyPolicy.data) { this.privacyNotice = privacyPolicy.data } else { this.privacyNotice = null }
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .agreement-box {
    background: #fff;
    padding: 15px;
  }
  .primary-header {
    border-bottom: 1px solid #f5f5f5;
    background: #fff;
    color: #000000;
  }
</style>
